import { Controller } from "@hotwired/stimulus"
import { Sortable } from 'sortablejs'
import { put } from '@rails/request.js'

// Connects to data-controller="checklist-sort"
export default class extends Controller {
  static values = {
    draggable: { type: String, default: '.item' },
    handle: { type: String, default: '.sortable-handle' },
    filtered: String
  }

  connect() {
    this.sortable = Sortable.create(this.element, this.#options)
  }

  disconnect() {
    if (this.sortable) {
      this.sortable.destroy();
    }
  }

  get #options() {
    let options = {
      handle: this.handleValue,
      draggable: this.draggableValue,
      onChange: (event) => {
        let url = event.item.dataset.updateUrl;
        put(url, { body: { position: event.newIndex } })
      }
    }

    if (this.hasFilteredValue) {
      options = { ...options, filtered: this.filteredValue }
    }

    return options;
  }
}
